import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const initialState = {
    rating: 0,
    feedback: "",
    isSubmitting: false,
    isSubmitted: false,
    error: "",
}

export const createSubmitFeedbackSlice = () => {
    return createSlice({
        name: "submitFeedback",
        initialState,
        reducers: {
            resetState: () => initialState,
            setRating: (state, action) => {
                state.rating = action.payload;
            },
            setFeedback: (state, action) => {
                state.feedback = action.payload;
            },
            setIsSubmitted: (state, action) => {
                state.isSubmitted = action.payload;
            }
        },
        extraReducers: (builder) => {
        }
    })
}